import React, { forwardRef } from 'react'

import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

export type DisclosureGap = 0 | 0.5 | 2 | 4

export const DisclosurePositionHorizon = {
  RIGHT: 'right',
  CENTER: 'center',
  LEFT: 'left'
} as const
export type DisclosurePositionHorizon =
  (typeof DisclosurePositionHorizon)[keyof typeof DisclosurePositionHorizon]

export const DisclosurePositionVertical = {
  BOTTOM: 'bottom',
  TOP: 'top'
} as const
export type DisclosurePositionVertical =
  (typeof DisclosurePositionVertical)[keyof typeof DisclosurePositionVertical]

export const DisclosureSize = {
  DEFAULT: 'default',
  MEDIUM: 'medium',
  FULL: 'full'
} as const
export type DisclosureSize = (typeof DisclosureSize)[keyof typeof DisclosureSize]

interface Props extends ChildProps {
  gap?: DisclosureGap
  fixed?: boolean
  horizon?: DisclosurePositionHorizon
  vertical?: DisclosurePositionVertical
  isForm?: boolean
  full?: boolean
  size?: DisclosureSize
}

const Disclosure = forwardRef<HTMLDivElement, Props>(
  (
    {
      children,
      gap = 0.5,
      fixed = false,
      horizon,
      vertical,
      isForm = false,
      full = false,
      size = DisclosureSize.DEFAULT
    },
    ref
  ) => {
    const gapClass = `gap-y-${gap}`

    return (
      <div
        ref={ref}
        style={{
          zIndex: 2000
        }}
        className={clsx(
          'z-modal bg-fill-primary shadow-300 whitespace-nowrap rounded-xl',
          fixed ? 'fixed' : 'absolute',
          size === DisclosureSize.MEDIUM
            ? 'w-[480px] min-w-[480px]'
            : size === DisclosureSize.FULL
            ? 'w-full'
            : 'min-w-[240px]',
          horizon === DisclosurePositionHorizon.CENTER && 'left-1/2 -translate-x-2/4',
          horizon === DisclosurePositionHorizon.LEFT && 'right-0',
          horizon === DisclosurePositionHorizon.RIGHT && 'left-0',
          vertical === DisclosurePositionVertical.TOP
            ? '-top-[4px] -translate-y-full'
            : 'top-[calc(100%+4px)]',
          full && 'left-0 right-0'
        )}
      >
        <div className='shadow-bevel-100 overflow-hidden rounded-xl'>
          <div
            className={clsx(
              ' scrollbar-y flex max-h-[400px] flex-col overflow-y-auto ',
              gapClass,
              isForm ? 'p-3' : 'p-1'
            )}
          >
            <div className='flex h-full flex-col gap-0.5 p-1!'>{children}</div>
          </div>
        </div>
      </div>
    )
  }
)

export default Disclosure
